/**
 * Created by Alex Aguilar on 7/19/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .directive('dateValidate', dateValidate)
        .directive('validateRadioInline', ['$timeout', validateRadioInline]);

    function dateValidate(){
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attributes) {
        }
    }

    function validateRadioInline($timeout){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attributes) {
            $timeout(function(){
                var eleJQ = element.find('input');
                if(eleJQ.hasClass('ng-invalid-required')){
                    element.prepend('<span class="inline-validate"></span>');
                    element.addClass('inline-validate-required');
                }
            });
        }
    }

})();
